<template>
    <base-layers-tree-item :item="item">
        <div class="layer-row pl-2">
            <div class="grow-1 d-flex items-center pr-1">
                <div class="action cursor-pointer no-drag" @click.prevent.capture="onCollapseClick()">
                    <font-awesome-icon v-if="collapsed" class="mr-1 action-icon" :icon="['fas', 'chevron-right']" />
                    <font-awesome-icon v-else class="mr-1 action-icon" :icon="['fas', 'chevron-down']" />
                </div>
                <div class="icon mr-2">
                    <template v-if="isSpotifyPlayer">
                        <c-lazy class="d-flex items-center element-icon">
                            <svg-icon :src="require(`../../../assets/spotify.svg`)" />
                        </c-lazy>
                    </template>
                    <template v-if="isLayout">
                        <div class="d-flex items-center element-icon">
                            <font-awesome-icon class="mr-1 status-icon" :icon="['fak', 'branch']" />
                        </div>
                    </template>
                    <template v-else>
                        <div class="d-flex items-center element-icon">
                            <font-awesome-icon class="mr-1 status-icon" :icon="['fas', 'layer-group']" />
                        </div>
                    </template>
                </div>
                <div class="layers-element-title grow-1">
                    <editable-text
                        :value="item.element.name"
                        :default-text="item.element.name"
                        :allow-editing="!flags?.readonly"
                        tooltip="Edit"
                        @input="onElementTitleChange"
                    />
                </div>
            </div>

            <div
                v-if="flags?.allowViewPositionGroup && item.element.position != 0"
                class="layers-element-title shrink cursor-pointer"
            >
                <editable-text
                    :value="item.element.position || ''"
                    label="ID"
                    type="number"
                    :allow-editing="flags?.allowPositionGroupEdit"
                    @input="onElementPositionChange"
                />
            </div>
        </div>
    </base-layers-tree-item>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import EditableText from '@/components/EditableText/EditableText.vue';
import CLazy from '@/components/CLazy.vue';
import SvgIcon from '@/components/SvgIcon/SvgIcon.vue';
import BaseLayersTreeItem from '../BaseLayersTreeItem.vue';
import type { ListElements } from '@/typings/customilyElements/layer';
import { useLayerTreeItem } from '@/components/Layers/composables/useLayerTreeItem';

const emit = defineEmits(['toggle-collapse']);

const props = defineProps<{
    item: ListElements;
    collapsed?: boolean;
}>();

const { flags, onElementTitleChange, onElementPositionChange } = useLayerTreeItem({
    item: props.item
});

const isSpotifyPlayer = computed(() => {
    return props.item.element.SpotifyPlayer;
});

const isLayout = computed(() => {
    return props.item.element.isLayout;
});

const onCollapseClick = () => {
    emit('toggle-collapse');
};
</script>

<style lang="scss" scoped>
.action-icon {
    fill: var(--secondary-color);

    &.selected {
        fill: #000;
    }
}
.status-icon {
    fill: var(--primary-blue);
    color: var(--primary-blue);

    &.selected {
        fill: #000;
        color: #000;
    }
}
</style>
